import { Link } from "react-router-dom";

interface ArticleCardProps {
  title: string;
  excerpt: string;
  slug: string;
  imageUrl: string;
}

export default function ArticleCard({ title, excerpt, slug, imageUrl }: ArticleCardProps) {
  return (
    <Link
      to={slug}
      className="group block bg-white rounded-xl border border-background-200/60 overflow-hidden hover:border-background-300/60 transition-all duration-300 cursor-pointer"
    >
      <div className="aspect-[4/3] overflow-hidden bg-background-100">
        <img
          src={imageUrl}
          alt={title}
          title={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
      </div>
      <div className="p-5">
        <h3 className="text-base font-semibold text-foreground-950 mb-2 leading-snug group-hover:text-primary-500 transition-colors duration-200">
          {title}
        </h3>
        <p className="text-sm text-foreground-600 leading-relaxed">
          {excerpt}
        </p>
        <div className="mt-3 flex items-center gap-1 text-sm text-primary-500">
          <span className="whitespace-nowrap">Ler artigo</span>
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </span>
        </div>
      </div>
    </Link>
  );
}